import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Heart, Sparkles } from 'lucide-react';
import { ReservationForm } from '../components/ReservationForm';
const trustItems = [{
  icon: CheckCircle2,
  title: 'Confirmación inmediata',
  text: 'Recibe la confirmación al instante en tu correo.'
}, {
  icon: Heart,
  title: 'Trato cercano',
  text: 'Te recibimos como en casa, con todo preparado.'
}, {
  icon: Sparkles,
  title: 'Ocasiones especiales',
  text: 'Cuéntanos qué celebras y prepararemos un detalle.'
}];
export function Reservas() {
  return <div className="py-12 md:py-20" data-id="element-391">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-392">
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-393">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-serif text-cafe-primary mb-6" data-id="element-394">
            Reserva tu Mesa
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg text-cafe-text/80" data-id="element-395">
            Asegura tu sitio en Trastienda Café. Rellena el formulario a
            continuación y prepararemos todo para tu visita.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto mb-14" data-id="element-396">
          {trustItems.map((item, i) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + i * 0.1,
          duration: 0.5
        }} className="text-center px-4" data-id="element-397">
              <div className="w-12 h-12 mx-auto bg-cafe-card rounded-full flex items-center justify-center mb-3" data-id="element-398">
                <item.icon className="text-cafe-accent" size={22} data-id="element-399" />
              </div>
              <h3 className="font-serif text-cafe-primary text-base mb-1" data-id="element-400">
                {item.title}
              </h3>
              <p className="text-cafe-text/70 text-sm leading-relaxed" data-id="element-401">
                {item.text}
              </p>
            </motion.div>)}
        </div>

        <ReservationForm data-id="element-402" />
      </div>
    </div>;
}